<template>
  <div>
    <!-- <a-slider
      :min="0"
      :max="100"
      tooltipVisible
      range
      :tipFormatter="tipFormatter"
      @change="slideChange"
    /> -->
    <div class="control">
      <a-button-group>
        <a-button @click="start" icon="caret-right"></a-button>
        <!-- <a-button @click="pause" icon="pause"></a-button> -->
        <a-button @click="pause">
          <zx-icon type="icon-tingzhi"></zx-icon></a-button>
        <a-select style="width: 100px" @change="speedChange" defaultValue="3000">
          <a-select-option value="500">{{$t('global.verySlow')}}</a-select-option>
          <a-select-option value="1000">{{$t('global.slow')}}</a-select-option>
          <a-select-option value="3000">{{$t('global.noraml')}}</a-select-option>
          <a-select-option value="5000">{{$t('global.fast')}}</a-select-option>
          <a-select-option value="8000">{{$t('global.veryFast')}}</a-select-option>
        </a-select>
      </a-button-group>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      value: 0,
      timer: ''
    }
  },
  methods: {
    slideChange (value) {
      // console.log(value)
      this.value = value
    },
    speedChange (speed) {
      // console.log(speed)
      let newSpeed = speed
      this.$emit('speedChanged', newSpeed)
    },
    tipFormatter (num) {
      // 将当前value转化为想要显示的内容
      // console.log(num)
      return `${num}%`
    },
    start () {
      // console.log(1)
      this.timer && clearInterval(this.timer)
      if (this.value < 100) {
        // console.log(2)
        this.$emit('trackStart')
        this.timer = setInterval(() => {
          this.value++
        }, 1000)
      } else {
        this.value = 0
        this.start()
      }
    },
    pause () {
      this.timer && clearInterval(this.timer)
      this.$emit('pause')
    },
    stop () {
      this.timer && clearInterval(this.timer)
      this.value = 0
      this.$emit('stop')
    }
  }
}
</script>
